import type { IntegrationSettingsSearch } from './-schema';
export type AdminConsentCallbackEffect = {
  type: 'none';
} | {
  type: 'success';
} | {
  type: 'error';
  message: string;
};

/**
 * BE が付与した Admin Consent callback クエリを、toast / invalidate の効果に変換する。
 * `softwareId` が付与されている場合は route params と一致しないと無視する（クロスソフトウェア誤表示防止）。
 */
export function resolveAdminConsentCallbackEffect(routeSoftwareId: string, search: IntegrationSettingsSearch): AdminConsentCallbackEffect {
  if (search.result == null) {
    return {
      type: 'none'
    };
  }
  if (search.softwareId != null && search.softwareId !== routeSoftwareId) {
    return {
      type: 'none'
    };
  }
  if (search.result === 'success') {
    return {
      type: 'success'
    };
  }
  return {
    type: 'error',
    message: search.errorMessage?.trim() || ''
  };
}